(function ($) {
	var $doc = $(document);
	var $body = $(document.body);

	// Gift list reorder select oprtions
	function giftSelectOrder() {
		var $gift = $('#gift_id');
		var options = $gift.find('option');
		var optionSelectedVal = $gift.find('option[selected]').val();

		options.detach().sort(function(a, b) {
				var at = $(a).text();
				var bt = $(b).text();
				return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
		});
		options.appendTo($gift);
		$gift.val(optionSelectedVal);

		giftRefreshOrder();
	}

	function giftRefreshOrder() {
		$('#gift_id').on('change', function (e) {
			$('button[name="update_cart"').trigger('click');
		});
	}

	giftRefreshOrder();

	$doc.ready(function($) {
		giftSelectOrder();
	});

	$body.on( 'updated_cart_totals', function() { 
		giftSelectOrder();
	});


	if ($body.hasClass('archive')) {
		var $htmlAndBody = $body.add('html');
		var $header = $('#header');
		var $toggleLinkMore = $('.facet-box__toggle-link--more');
		var $toggleLinkLess = $('.facet-box__toggle-link--less');
		var $toggleList = $('.facet-box__toggle-list');

		// refresh facetwp
		function refreshFilter() {
				FWP.refresh();
		}

		// reset facetwp
		function resetFilter() {
				FWP.reset();
		}

		// get every variable in query string, and when there is a relative checkbox check it
		location.search.replace('?', '').split('&').forEach(function (val) {
				split = val.split("=", 2);
				if ('undefined' !== split[0] && 'undefined' !== split[1] && '1' === split[1]) {
						$('.custom-checkbox-filter[data-url-segment=' + split[0] + ']').prop('checked', true);
				}
		});

		// when a variable is pop refresh facetwp
		$(window).on('popstate', function (e) {
				refreshFilter();
		});

		$('.custom-checkbox-filter').on('change', function (e) {
				// if checkbox is checked add variable to url
				if ($(this).is(':checked')) {
						let params = new URLSearchParams(window.location.search);
						params.set($(this).data('url-segment'), '1');
						window.history.pushState({}, null, decodeURIComponent(`${window.location.pathname}?${params}`));
				} else {
						// if checkbox is unchecked remove variable from url
						let params = new URLSearchParams(window.location.search);
						params.delete($(this).data('url-segment'));
						window.history.pushState({}, null, '?' + params + location.hash);
				}

				refreshFilter();
		});

		// click on reset button will remove query string, uncheck all checkboxes and reset facetwp
		$('.facet-reset').on('click', function (e) {
				window.history.pushState({}, null, window.location.pathname);
				$('.custom-checkbox-filter').prop('checked', false);
				resetFilter();
		});

		// Filters box behavior
		$toggleLinkMore.show();
		$toggleList.add($toggleLinkLess).hide();

		$toggleLinkMore.on('click', function() {
			$toggleList.add($toggleLinkLess).show();
			$toggleLinkMore.hide();
			$htmlAndBody.animate({
				scrollTop: $toggleList.offset().top - ($header.innerHeight() + 50)
						}, 400);
		});

		$toggleLinkLess.on('click', function() {
			$toggleList.hide();
			$toggleLinkMore.show();
			$toggleLinkLess.hide();
			$htmlAndBody.animate({
				scrollTop: $(".facet-box__list").offset().top - ($header.innerHeight() + 50)
						}, 400);
		});

		$('.facet-box__item-title').on('click', function() {
			$(this).closest('.facet-box__item').toggleClass('facet-box__item--reduced');
		});

		$doc.on('facetwp-loaded', function() {
			if (FWP.loaded) {
				$htmlAndBody.animate({
					scrollTop: $('.facetwp-template').offset().top - $header.outerHeight() - 50
				}, 500);
			}
		});
	}
})(jQuery);